module.exports = __webpack_public_path__ + "img/lp-logo@2x.a78a1555.png";